import React from 'react';
import { useDateService } from 'framework/utils';
import { Box, Typography } from '@mui/material';
import RemainedDaysChip from './RemainedDaysChip';
import { useListContext } from 'framework/list';

const SickDaysSectionHeader: React.FC = () => {
  const { data: { items = [] } = {} } = useListContext();
  const { isCurrentTimeInPeriod } = useDateService();

  const currentPeriodSickDays =
    items.find(item => isCurrentTimeInPeriod(item.startDate, item.endDate))?.sickDaysRemainedBalance || '0';
  const isPolishContractor = items.some(item => item.isPolishContractor);

  return (
    <Box display="flex" alignItems="anchor-center" gap={2}>
      <Typography variant="h4">Sick days</Typography>
      {!isPolishContractor && <RemainedDaysChip label={`${currentPeriodSickDays}d`} />}
    </Box>
  );
};

export default SickDaysSectionHeader;
